import { connect } from 'react-redux';

import DeliveryTypesListComponent from './DeliveryTypesListComponent';

import { getCountries, getDeliveryTypes, removeDeliveryType } from './actions';

const DeliveryTypesListContainer = (props) => (
  <DeliveryTypesListComponent {...props} />
);

const mapStateToProps = (state) => {
  const {
    common: { deliveryTypes, countries },
  } = state;

  let items = [];

  if (countries?.length > 0 && deliveryTypes?.length > 0) {
    items = deliveryTypes.map((type) => {
      const countriesList = type?.countries
        ?.map((id) => countries?.find((country) => country?.id === id)?.name)
        .join(', ');
      return {
        ...type,
        countriesList,
      };
    });
  }

  return {
    countries,
    items,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (queryParams) => {
    getCountries(dispatch, queryParams);
    getDeliveryTypes(dispatch, queryParams);
  },
  onDeliveryTypeRemove: (id) => removeDeliveryType(dispatch, id),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryTypesListContainer);
